import Spinner from "../../shared/ui/Loading/Spinner";

/**
 * Shared Task workspace page header for /tasks and /tasks/calendar.
 * Primary create action reuses the canonical CRM Clients `.btn-more` CTA.
 */
function TaskWorkspaceHeader({
  subtitle,
  onCreate,
  onRefresh,
  refreshing = false,
  refreshDisabled = false,
  showRefresh = true,
}) {
  return (
    <section className="clients-overview" aria-label="Огляд задач">
      <header className="clients-header feature-tasks-workspace__page-header">
        <div className="clients-header__text">
          <h1 className="clients-header__title">Задачі</h1>
          <p className="clients-header__sub">{subtitle}</p>
        </div>
        <div className="clients-header__actions feature-tasks-workspace__header-actions">
          <button
            type="button"
            className="btn-more"
            onClick={onCreate}
            aria-label="Створити задачу"
            data-testid="task-workspace-create"
          >
            <i className="fa-solid fa-plus" aria-hidden="true" />
            Створити задачу
          </button>
          {showRefresh ? (
            <button
              type="button"
              className="action-btn"
              onClick={onRefresh}
              disabled={refreshDisabled || refreshing}
              aria-label="Оновити"
            >
              {refreshing ? (
                <Spinner size="sm" label="Оновлення" />
              ) : (
                "Оновити"
              )}
            </button>
          ) : null}
        </div>
      </header>
    </section>
  );
}

export default TaskWorkspaceHeader;
